<template>
  <ul
    class="pagination"
    :class="[size && `pagination-${size}`, align && `justify-content-${align}`]"
  >
    <li
      class="page-item prev-page"
      :class="{ disabled: pageInfo.pageBlock === 1 }"
      v-show="pageInfo.pageBlock !== 1"
    >
      <a class="page-link" aria-label="Previous" v-on:click="prevBlock">
        <span aria-hidden="true"
        ><i class="fa fa-angle-double-left" aria-hidden="true"></i
        ></span>
      </a>
    </li>
    <li
      class="page-item prev-page"
      :class="{ disabled: pageInfo.page === 1 }"
      v-show="pageInfo.page !== 1"
    >
      <a class="page-link" aria-label="Previous" v-on:click="prevPage">
        <span aria-hidden="true"
        ><i class="fa fa-angle-left" aria-hidden="true"></i
        ></span>
      </a>
    </li>
    <li
      class="page-item"
      :class="{ active: value === item }"
      :key="item"
      v-for="item in pageList"
    >
      <a class="page-link" v-on:click="changePage(item)">{{ item }}</a>
    </li>
    <li
      class="page-item next-page"
      :class="{ disabled: pageInfo.page === pageInfo.totalPage }"
      v-show="pageInfo.page !== pageInfo.totalPage"
    >
      <a class="page-link" aria-label="Next" v-on:click="nextPage">
        <span aria-hidden="true"
        ><i class="fa fa-angle-right" aria-hidden="true"></i
        ></span>
      </a>
    </li>
    <li
      class="page-item next-page"
      :class="{ disabled: pageInfo.pageBlock === pageInfo.totalBlock }"
      v-show="pageInfo.pageBlock !== pageInfo.totalBlock"
    >
      <a class="page-link" aria-label="Next" v-on:click="nextBlock">
        <span aria-hidden="true"
        ><i class="fa fa-angle-double-right" aria-hidden="true"></i
        ></span>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'base-pagination',
  props: {
    pageInfo: {
      type: Object
    },
    size: {
      type: String,
      default: '',
      description: 'Pagination size'
    },
    align: {
      type: String,
      default: '',
      description: 'Pagination alignment (e.g center|start|end)'
    },
    value: {
      type: Number,
      default: 1
    }
  },
  computed: {
    pageList() {
      return this.$_.range(this.pageInfo.startPage, this.pageInfo.endPage + 1)
    },
    totalPages() {
      if (this.pageCount > 0) return this.pageCount
      if (this.total > 0) {
        return Math.ceil(this.total / this.perPage)
      }
      return 1
    },
    pagesToDisplay() {
      if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
        return this.totalPages
      }
      return this.defaultPagesToDisplay
    }
  },
  data: function() {
    return {
      defaultPagesToDisplay: 5,
      total: this.pageInfo.totalPage,
      perPage: this.pageInfo.rowPerPage,
      pageCount: 0
    }
  },
  methods: {
    range(min, max) {
      const arr = []
      for (let i = min; i <= max; i++) {
        arr.push(i)
      }
      return arr
    },
    changePage(item) {
      this.$emit('change', item)
    },
    nextPage() {
      if (this.value < this.pageInfo.totalPage) {
        this.$emit('change', this.value + 1)
      }
    },
    prevPage() {
      if (this.value > 1) {
        this.$emit('change', this.value - 1)
      }
    },
    prevBlock() {
      if (this.pageInfo.isPrevBlock) {
        this.$emit(
          'change',
          this.pageInfo.pagePerBlock * (this.pageInfo.pageBlock - 1)
        )
      }
    },
    nextBlock() {
      if (this.pageInfo.isNextBlock) {
        this.$emit(
          'change',
          this.pageInfo.pagePerBlock * this.pageInfo.pageBlock + 1
        )
      }
    }
  },
  watch: {
    perPage() {
      this.$emit('change', 1)
    },
    total() {
      this.$emit('change', 1)
    }
  }
}
</script>

<style lang="scss">
.pagination {
  display: -ms-flexbox;
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}

.pagination a {
  cursor: pointer;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #007bff;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.page-link:hover {
  z-index: 2;
  color: #0056b3;
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.page-link:focus {
  z-index: 2;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}
.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}
</style>
